import debounce from 'lodash-es/debounce';
import each from 'lodash-es/each';
import initImageCarousel from './initImageCarousel';
import initContentCarousel from './initContentCarousel';
import initMobileCarousel from './initMobileCarousel';

export default class {
  constructor(el) {
    this.el = el;
    this.imageCarousels = [];
    this.contentCarousel = null;
    this.mobileCarousel = null;

    this.init = this.init.bind(this);
    this.handleResize = this.handleResize.bind(this);
    this.updateImageSlides = this.updateImageSlides.bind(this);

    this.init();

    window.addEventListener(
      'resize',
      debounce(() => {
        this.handleResize();
      }, 500),
    );

    document.addEventListener('shopify:section:load', () => {
      this.destroy();
      this.init();
    });
  }

  init() {
    const contentCarouselEl = this.el.querySelector('[data-hero-dual-image-content-carousel]');
    const mobileCarouselEl = this.el.querySelector('[data-hero-dual-image-content-carousel-mobile]');
    this.imageCarousels = [];
    this.el.querySelectorAll('[data-hero-dual-image-carousel]').forEach((el) => {
      this.imageCarousels.push(initImageCarousel(el));
    });
    this.contentCarousel = initContentCarousel(contentCarouselEl);
    this.contentCarousel.on('change', (i) => {
      this.updateImageSlides(i);
    });
    this.mobileCarousel = initMobileCarousel(mobileCarouselEl);
  }

  destroy() {
    try {
      this.imageCarousels.forEach((carousel) => {
        carousel.destroy();
      });

      if (this.contentCarousel) this.contentCarousel.destroy();
      if (this.mobileCarousel) this.mobileCarousel.destroy();
    } catch (error) {
      console.log(error);
    }
  }

  handleResize() {
    this.destroy();
    this.init();
  }

  updateImageSlides(i) {
    each(this.image_carousels, (carousel) => {
      const ind = carousel.selectedIndex;
      const num = carousel.cells.length;

      // Wrapping doesn't work right if there's only 2
      // Not sure how to fix this
      if (num <= 2) {
        carousel.select(i);
        return;
      }

      if (ind === num - 1 && i === 0) {
        carousel.next();
      } else if (ind === 0 && i === num - 1) {
        carousel.previous();
      } else {
        carousel.select(i);
      }
    });
  }
}
